import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import {Member} from "../api/Models";
import {PURGE} from "redux-persist/es/constants";

export interface MemberState {
  members: Member[]
}

// Define the initial state using that type
const initialState: MemberState = {
  members: []
}

export const membersSlice = createSlice({
  name: 'members',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    setMembers: (state, action: PayloadAction<Member[]>) => {
      state.members = action.payload;
    },
    addMember: (state, action: PayloadAction<Member>) => {
      state.members = [
        ...state.members,
        action.payload
      ]
    },
    updateMember: (state, action: PayloadAction<Partial<Member>>) => {
      state.members = state.members.map((m) => {
        if (m.id === action.payload.id) {
          return {
            ...m,
            ...action.payload
          }
        } else {
          return m
        }
      })
    },
    removeMember: (state, action: PayloadAction<string>) => {
      state.members = state.members.filter((m) => m.id !== action.payload)
    }
  }
})

export const { setMembers, addMember, removeMember, updateMember } = membersSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectMembers = (state: RootState) => state.members.members
export const selectFrontingMembers = (state: RootState) => state.members.members.filter((m) => m.isFronting)
export const selectFrontingName = (state: RootState) => {
  return state.members.members.filter((m) => m.isFronting).map((f) => f.name).join(', ')
}

export default membersSlice.reducer